__turbopack_export_value__({
  "selectPhone": "style-module-scss-module__3kC9EG__selectPhone",
  "selectPhone__content": "style-module-scss-module__3kC9EG__selectPhone__content",
});
